import { createAction, props } from "@ngrx/store";
import { FeatureFlagModel } from "../../../models/feature-flags-model";

export const LOAD_FEATURE_FLAG_ADOPTER_HUB = '[FeatureFlagAdopterHub] Load FeatureFlagAdopterHub';
export const SET_FEATURE_FLAG_ADOPTER_HUB = '[FeatureFlagAdopterHub] Set FeatureFlagAdopterHub';
export const RESET_FEATURE_FLAG_ADOPTER_HUB = '[FeatureFlagAdopterHub] Reset FeatureFlagAdopterHub';

export const loadFeatureFlagAdopterHub = createAction(LOAD_FEATURE_FLAG_ADOPTER_HUB);
export const setFeatureFlagAdopterHub = createAction(SET_FEATURE_FLAG_ADOPTER_HUB, props<{
  featureFlagAdopterHub: FeatureFlagModel | null
}>());
export const resetFeatureFlagAdopterHub = createAction(RESET_FEATURE_FLAG_ADOPTER_HUB);
